import { PAYEX_URL } from 'constants/config';
import { decamelizeKeys } from 'humps';
import { fetchJson } from 'utils/fetchJson/fetchJson';

import type {
  SendOtpParams,
  SendOtpResponse,
  SmsEligibilityParams,
  SmsEligibilityResponse,
  VerifyOtpParams,
  VerifyOtpResponse,
} from './types';

export const otp = {
  send: (params: SendOtpParams) => {
    const path = `${PAYEX_URL}/otp`;
    const recipient =
      params.channel === 'sms'
        ? (params.phone ?? '').replace(/\s/g, '')
        : params.email;
    const { phone: _, ...rest } = params;
    const body = JSON.stringify(decamelizeKeys({ ...rest, recipient }));

    return fetchJson<SendOtpResponse>(path, { method: 'POST', body });
  },

  verify: (params: VerifyOtpParams) => {
    const path = `${PAYEX_URL}/otp/verify`;
    const body = JSON.stringify(params);

    return fetchJson<VerifyOtpResponse>(path, { method: 'POST', body });
  },

  smsEligibility: ({ platform, countryFrom }: SmsEligibilityParams = {}) => {
    const searchParams = new URLSearchParams();

    if (platform) {
      searchParams.append('platform', platform);
    }
    if (countryFrom) {
      searchParams.append('country_from', countryFrom);
    }

    const queryString = searchParams.toString();
    const path = `${PAYEX_URL}/otp/sms_eligibility${queryString ? `?${queryString}` : ''}`;

    return fetchJson<SmsEligibilityResponse>(path);
  },
};
